import {RockBottom} from "../RockBottom";
import {RockBottomGameAssets} from "../RockBottomGameAssets";
import {RockBottomParsedInitData} from "../server/data/RockBottomParsedInitData";
import {RockBottomParsedGameData} from "../server/data/RockBottomParsedGameData";
import {RockBottomGameMode} from "../server/RockBottomGameMode";
import {TweenLite} from "gsap";
import {RockBottomSound} from "../sound/RockBottomSound";

export class PolaroidSymbol extends PIXI.Container {
    private static STATE_NORMAL: string = "_Clean";
    private static STATE_DRINK: string = "_Drink";
    private static STATE_WORN_OUT: string = "_WornOut";
    private static MULT_PREFIX: string = "x";
    private readonly _name: string;
    private _imgNormal: PIXI.Sprite;
    private _imgDrink: PIXI.Sprite;
    private _imgPolaroid: PIXI.Sprite;
    private _multiplier: PIXI.BitmapText;

    constructor(symbolName: string) {
        super();
        this._name = symbolName;
        this.init();
    }

    get getCurrMultValue(): number {
        let multValueStr: string = this._multiplier.text.replace(PolaroidSymbol.MULT_PREFIX, "");
        if (multValueStr === "") {
            multValueStr = "1";
        }
        return parseInt(multValueStr);
    }

    public setAsActive(flag: boolean): void {
        const parsedData: RockBottomParsedInitData | RockBottomParsedGameData = RockBottom.getParsedData();
        if (parsedData.mode === RockBottomGameMode.SUPER_FREESPIN || parsedData.nextMode === RockBottomGameMode.SUPER_FREESPIN) {
            this._imgNormal.visible = false;
            this._imgDrink.visible = true;
        } else {
            this._imgNormal.visible = true;
            this._imgDrink.visible = false;
        }
        this._imgNormal.tint = flag ? 0xffffff : 0x555555;
        this._imgDrink.tint = flag ? 0xffffff : 0x555555;
        this._imgPolaroid.visible = false;
    }

    public setWornOut(): void {
        this._imgNormal.visible = false;
        this._imgDrink.visible = false;
        this._imgPolaroid.visible = true;
    }

    public resetMultiplier(): void {
        this._multiplier.text = "";
        this._multiplier.visible = false;
    }

    public updateMultiplier(val?: number): void {
        const parsedData: RockBottomParsedInitData | RockBottomParsedGameData = RockBottom.getParsedData();

        let multValue: number | undefined = val;

        const indexToChoose: number = parseInt(this._name.replace("M", "")) - 1,
            serverValue: number = parsedData.fsSymbolMultiplier[indexToChoose];

        if (multValue) {
            if (multValue > serverValue) {
                multValue = serverValue;
            } else {
                multValue = val;
            }
        } else {
            multValue = serverValue;
        }

        if (this._multiplier.text !== PolaroidSymbol.MULT_PREFIX + multValue) {
            this._multiplier.text = PolaroidSymbol.MULT_PREFIX + multValue;
            this._multiplier.pivot.set(this._multiplier.width / 2, this._multiplier.height / 2);

            if (multValue !== 1 && indexToChoose !== 4 && (indexToChoose !== parsedData.fsLevel)) {
                if (!RockBottomSound.soundPlayer.fetchSoundPlayer(RockBottomSound.MULTIPLIER_UPDATE)?.isPlaying) {
                    RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.MULTIPLIER_UPDATE});
                }
            }

            TweenLite.to(this._multiplier.scale, {
                x: 1.15,
                y: 1.15,
                duration: 0.05,
                onComplete: () => {
                    TweenLite.to(this._multiplier.scale, {
                        x: 1,
                        y: 1,
                        duration: 0.05
                    });
                }
            });
        }

        if (multValue && multValue > 1) {
            this._multiplier.visible = true;
            this._multiplier.pivot.set(this._multiplier.width / 2, this._multiplier.height / 2);
        } else {
            this._multiplier.visible = false;
        }
        if (this._name === "M2" || this._name === "M4") {
            this._multiplier.rotation = 0.3;
            this._multiplier.position.set(23, 60);
        } else {
            this._multiplier.rotation = 0.1;
            this._multiplier.position.set(30, 55);
        }
        this._multiplier.visible = true;
    }

    private init(): void {
        this._imgNormal = this.setSprite(PolaroidSymbol.STATE_NORMAL);
        this._imgDrink = this.setSprite(PolaroidSymbol.STATE_DRINK);
        this._imgPolaroid = this.setSprite(PolaroidSymbol.STATE_WORN_OUT);
        this._multiplier = this.createMultiplier();
        this.addChild(this._imgNormal, this._imgDrink, this._imgPolaroid, this._multiplier);

        const pos: PIXI.Point = this.getPositions();
        this.position.set(pos.x, pos.y);
    }

    private createMultiplier(): PIXI.BitmapText {
        const text: PIXI.BitmapText = new PIXI.BitmapText("", {
            fontName: RockBottomGameAssets.BITMAP_ON_POLAROID,
            fontSize: 20
        });
        text.visible = false;
        return text;
    }

    private setSprite(state: string): PIXI.Sprite {
        const imgSprite: PIXI.Sprite = new PIXI.Sprite(RockBottom.assetLoader.getTextures(this._name + state)[0]);
        imgSprite.anchor.set(0.5);
        imgSprite.visible = false;

        return imgSprite;
    }

    private getPositions(): PIXI.Point {
        switch (this._name) {
            case "M1":
                return new PIXI.Point(0, -100);
            case "M2":
                return new PIXI.Point(0, 100);
            case "M3":
                return new PIXI.Point(0, -145);
            case "M4":
                return new PIXI.Point(0, 0);
            case "M5":
                return new PIXI.Point(0, 145);
            default:
                return new PIXI.Point(0, 0);
        }
    }
}